import moment from 'moment'

export default class Renda {

    constructor(anoReferencia=moment(new Date()).year()-1, valor=0) {
        this.anoReferencia = anoReferencia;
        this.valor = valor;
    }
}



// WEBPACK FOOTER //
// ./src/domain/dependencia/renda.js